import { createApp } from 'vue';
import ShareView from '../../gc10-report/ShareView.vue'

const appElements = document.querySelectorAll('.vue-gc10-share-view')
Array.from(appElements).forEach(element => {
  createApp(ShareView).mount(element);
});